import { lazy, type ComponentType } from 'react';
import { Permission } from '../types/user';

const LoginPage = lazy(() => import('../pages/LoginPage'));
const AdminPage = lazy(() => import('../pages/AdminPage'));
const UserSettingsPage = lazy(() => import('../pages/UserSettingsPage'));
const RunsHomePage = lazy(() => import('../pages/foam/RunsHomePage'));
const ProcessPage = lazy(() => import('../pages/foam/ProcessPage'));
const ChemicalsPage = lazy(() => import('../pages/foam/ChemicalsPage'));
const CostingPage = lazy(() => import('../pages/foam/CostingPage'));
const DatabasePage = lazy(() => import('../pages/foam/DatabasePage'));
const TestDataPage = lazy(() => import('../pages/foam/TestDataPage'));
const ForbiddenPage = lazy(() => import('../pages/ForbiddenPage'));

export type AppRouteEntry = {
  path: string;
  page: ComponentType;
  permission?: Permission;
  public?: boolean;
};

export const APP_ROUTES: AppRouteEntry[] = [
  { path: '/login', page: LoginPage, public: true },
  { path: '/', page: RunsHomePage, permission: Permission.ViewProductionRuns },
  { path: '/process', page: ProcessPage, permission: Permission.ViewProductionRuns },
  { path: '/chemicals', page: ChemicalsPage, permission: Permission.ViewProductionRuns },
  { path: '/costing', page: CostingPage, permission: Permission.ViewProductionRuns },
  { path: '/database', page: DatabasePage, permission: Permission.ViewFoamReferential },
  { path: '/test-data', page: TestDataPage, permission: Permission.ViewProductionRuns },
  { path: '/admin', page: AdminPage, permission: Permission.ViewUsers },
  { path: '/settings', page: UserSettingsPage },
  { path: '/forbidden', page: ForbiddenPage },
];
